import React from 'react';
import Layout from '../../components/Layout';
import TrustSafety from './TrustSafety';

const title = 'Trust & Safety — Verified Pros, Protected Payments | BestHand';
// COMPLIANCE: background-check claim is intentional (founder confirms BestHand performs background checks). LEGAL_REVIEW_REQUIRED before prod.
const description =
  'BestHand pros are background-checked, payments are secure and cashless in-app, and our team helps make every booking right.';

function action() {
  return {
    title,
    description,
    component: (
      <Layout>
        <TrustSafety />
      </Layout>
    ),
  };
}

export default action;
